import {
	keyBy
} from "src/app/shared/utils";

import {
	paymentMethodTypes
} from 'tilby-models'

export const paymentMethodTypesById = keyBy(paymentMethodTypes, (m) => m.id);

export function isCashdrawerMethod(typeId: number) {
	return typeId !== 1 && paymentMethodTypesById[typeId]?.class === "cash";
}

export function isPMS(typeId: number) {
	return paymentMethodTypesById[typeId]?.class === "pms";
}